var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7683 17.793C9.35691 18.3105 10.1294 18.6237 10.9748 18.6221C11.8201 18.6205 12.5914 18.3043 13.178 17.7845M15.9523 6.94583C15.9497 5.61975 15.4205 4.349 14.481 3.41312C13.5415 2.47725 12.2688 1.95291 10.9427 1.95546C9.61659 1.95802 8.34584 2.48725 7.40996 3.42673C6.47409 4.36622 5.94975 5.639 5.9523 6.96508C5.95726 9.54023 5.31105 11.3046 4.58762 12.4722C3.9774 13.4571 3.67229 13.9496 3.68378 14.0868C3.6965 14.2387 3.7288 14.2965 3.8514 14.3871C3.96213 14.4689 4.46057 14.468 5.45745 14.466L16.476 14.4448C17.4729 14.4429 17.9713 14.442 18.0817 14.3597C18.204 14.2687 18.2361 14.2107 18.2482 14.0587C18.2592 13.9215 17.9522 13.4302 17.3382 12.4477C16.6102 11.2829 15.9572 9.52098 15.9523 6.94583Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.c90a081204b56f82d0a722f787adbff0.svg";
export { ForwardRef as ReactComponent };